export default {
  newDesign: true,
  title: "Odpowiedz na kilka pytań i uzyskaj dostęp do BEZPŁATNEGO KURSU! | Kodland",
  downtimeUrl: "https://www.kodland.org/pl",
  parameters: {
    landing_id: "PlQSF",
    segment: 7,
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Dziękujemy za zaufanie naszej platformie edukacyjnej!",
    subtitle:
      "Niestety, tablety lub telefony nie nadają się do korzystania z naszych lekcji. Będziemy szczęśliwi, widząc Was na naszych zajęciach następnym razem!",
  },
  quizRotateBySteps: {
    1: {
      question: "Chcesz, by czas Twojego dziecka przy komputerze był bardziej produktywny?",
      answers: ["🔥 Tak!", "😎 Nie, nie tylko dla zabawy i to też w porządku"],
      coverImageDesk: { url: "/welcome/pl_rob_cover_v2_desk.png" },
      coverImageMob: { url: "/welcome/pl_rob_cover_v2_mob.png" },
      isCover: true,
    },
    2: {
      title: "Ile lat ma Twoje dziecko? 🎂",
      type: "age",
      button: "",
    },
    3: {
      question: "Czy Twoje dziecko lubi grać w gry, takie jak Roblox lub Minecraft?",
      answers: [
        "Tak, uwielbia je! 🎮",
        "Ale nie często 🤔",
        "Czasami 🤷‍♂️"
      ],
    },
    4: {
      question: "Czy Twoje dziecko lubi tworzyć postacie, historie lub własne światy?",
      answers: [
        "Tak, ma bardzo rozwiniętą wyobraźnię ✨",
        "Nie za bardzo, woli inne zajęcia 🎮",
        "Trochę, ale potrzebuje wskazówek 🤔"
      ],
    },
    5: {
      question: "Czy Twoje dziecko lubi rozwiązywać zagadki lub rozumieć, jak działają gry?",
      subtitle: "To pomoże nam odpowiednio dobrać wykwalifikowanego nauczyciela pod charakter Twojego dziecka.",
      answers: [
        "Tak, lubi wyzwania i łamigłówki 🧩",
        "Nie, woli prostsze gry 🎮",
        "Czasami, jeśli jest to część gry 🧐"
      ],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle: "Oferujemy naukę indywidualną i grupową, dopasowaną do wieku i potrzeb każdego dziecka.",
      button: "Zaczynajmy!",
    },
    7: {
      question: "Czy Twoje dziecko ma dostęp do komputera lub laptopa?",
      answers: [
        "Tak 💻",
        {
          answer: "Nie 🚫",
          stopAnswer: true,
        },
      ],
    },
    8: {
      title: "Jeszcze tylko jeden krok!",
      typeInfo: "congrats",
      subtitle:
        "Pomóż swojemu dziecku odkrywać kreatywną stronę poprzez programowanie i projektowanie cyfrowe.<br>Już ponad 200 000 dzieci tworzy i uczy się z nami.",
      button: "Zarezerwuj darmową lekcję!",
    },
    9: {
      title: "Uzupełnij dane kontaktowe, aby uzyskać dostęp do darmowego kursu",
      type: "one-page-contacts",
      subtitle: "",
      button: "Prawie skończone 🔥",
    },
    10: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    11: {
      title: "Przejrzyj te informacje, aby zakończyć rejestrację ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Pamiętaj, że do lekcji będziesz potrzebować działającego komputera stacjonarnego lub laptopa i musisz towarzyszyć swojemu dziecku przez cały czas trwania zajęć. Pamiętaj, że zajęcia są indywidualne i spersonalizowane.",
      button: "Co jeszcze?",
    },
    12: {
      title:
        "Przed zajęciami próbnymi sprawdź swoją skrzynkę e-mail i WhatsApp 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Na 24 godziny przed zajęciami wyślemy przypomnienie, a na 2 godziny przed zajęciami poprosimy o potwierdzenie obecności. Bardzo ważne jest, abyśmy pozostali w kontakcie, aby zajęcia nie zostały odwołane.",
      button: "Co jeszcze?",
    },
    13: {
      title: "Lekcja odbędzie się na naszej platformie 💻",
      typeInfo: "classroom",
      subtitle:
        "Otrzymasz link i unikalny kod przez WhatsApp oraz e-mail. Wystarczy kliknąć w link, a przeniesie Cię on prosto do lekcji. Bez dodatkowych aplikacji, bez pobierania.",
      button: "Rozumiem ✅",
    },
  },
};
